
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { ReferralAdminDashboard } from "@/components/admin/ReferralAdminDashboard";
import { CSOLoadingSpinner } from "@/components/ui/cso-loading-spinner";

const AdminReferrals = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          toast({
            title: "Authentication Required",
            description: "Please sign in to access the admin dashboard.",
            variant: "destructive",
          });
          navigate('/auth');
          return;
        }

        // Check if user is admin (you can modify this logic based on your admin system)
        // For now, checking if email contains 'admin' or is a specific admin email
        const userEmail = session.user.email;
        const isAdmin = userEmail?.includes('admin') || 
                       userEmail === 'admin@csoagent.com' || 
                       userEmail === 'your-admin-email@domain.com'; // Replace with your admin email

        if (!isAdmin) {
          toast({
            title: "Access Denied",
            description: "You don't have permission to access the admin dashboard.",
            variant: "destructive",
          });
          navigate('/');
          return;
        }

        setIsAuthorized(true);
      } catch (error) {
        console.error('Error checking admin access:', error);
        toast({
          title: "Error",
          description: "There was a problem verifying your access.",
          variant: "destructive",
        });
        navigate('/');
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminAccess();
  }, [navigate, toast]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <CSOLoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthorized) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <ReferralAdminDashboard />
    </div>
  );
};

export default AdminReferrals;
